import type { InitOptions } from './types/InitOptions.js';
import type { CommandAction, CommandExitParams } from '../../types/CommandAction.js';
import { init } from './init.js';
import { formatInitSummary } from './formatInitSummary.js';
import { InitSummaryData } from './InitSummaryData.js';

/** Given the path, updates the Cloudpack config with overrides and project settings. */
export const execute: CommandAction<InitOptions> = async (params) => {
  const { appPath, isMultiApp, options, setInterruptMessageHandler } = params;

  const summaryData = new InitSummaryData({ appPath, check: options.check });

  const formatResult = (isInterrupted?: boolean): CommandExitParams => {
    const summary = summaryData.summarize();
    const message = formatInitSummary({
      summary,
      isInterrupted,
      check: options.check,
      isMultiApp,
      verb: 'init',
    });
    return { message, hasErrors: summary.failed, isInterrupted };
  };

  setInterruptMessageHandler(() => formatResult(true).message);

  await init({ summaryData, ...params });

  return formatResult();
};
